import { EDUCATIONS } from "../constants/step-one.constants";
import { Profile } from "../../../hooks/use-get-profile";
import { STEP_ONE_INITIAL_VALUES } from "../constants/step-one.constants";
import { EducationInitialValues } from "../education.types";

export const isEducationLessThanDiploma = (educationId: number | string) => {
    const matchingEducation = EDUCATIONS.find((e) => e.id == educationId);
    if (matchingEducation && matchingEducation.ordered_id < 3) {
        return true;
    }
    return false;
};

export const isEducationGraduateAndAbove = (educationId: number | string) => {
    const matchingEducation = EDUCATIONS.find((e) => e.id == educationId);
    if (matchingEducation && matchingEducation.ordered_id >= 5) {
        return true;
    }
    return false;
};

export const isEducationDiplomaAndAbove = (educationId: number | string) => {
    const matchingEducation = EDUCATIONS.find((e) => e.id == educationId);
    if (matchingEducation && (matchingEducation.ordered_id >= 5 || matchingEducation.ordered_id === 3)) {
        return true;
    }
    return false;
};

export const transformBodyToEducationForm = (profileData: Profile) => {
    const education = profileData?.educations;

    if (Array.isArray(education) && education.length > 0) {
        let educationData: EducationInitialValues = JSON.parse(
            JSON.stringify(STEP_ONE_INITIAL_VALUES)
        ) as EducationInitialValues;

        const currentEducation = education
            ? education.find(
                  (edu) =>
                      edu?.education_level?.id == profileData.highest_education_level?.id
              )
            : null;

        if (currentEducation) {
            educationData.highest_education_level_id = currentEducation.education_level
                .id as any;

            if (currentEducation?.id) {
                educationData.id = currentEducation.id;
            }

            if (currentEducation?.course) {
                educationData.course = {
                    id: currentEducation.course.id,
                    title: currentEducation.course.title,
                };
            }

            if (currentEducation?.specialization) {
                educationData.specialization = {
                    id: currentEducation.specialization.id,
                    title: currentEducation.specialization.title,
                };
            }

            if (currentEducation.education_institute) {
                educationData.college = {
                    id: currentEducation.education_institute.id,
                    name: currentEducation.education_institute.title,
                };
            }

            if (currentEducation.education_type) {
                educationData.education_type = currentEducation.education_type;
            }

            if (currentEducation.end) {
                const date = new Date(currentEducation.end)
                educationData.completionYear = currentEducation.end.toString();
                educationData.degreeYear = date.getFullYear()
                educationData.degreeMonth = date.getMonth()
            }

            if (currentEducation.start) {
                educationData.start = currentEducation.start
            }

            return educationData;
        }
    }
    return JSON.parse(
        JSON.stringify({
            ...STEP_ONE_INITIAL_VALUES,
            highest_education_level_id: profileData?.highest_education_level?.id,
        })
    ) as EducationInitialValues;
};
